/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BinaryFileType } from '../models/binary-file-type';
import { ConsigneeDeliveryNotesInPool } from '../models/consignee-delivery-notes-in-pool';
import { DeliveryNoteMetaDataResponse } from '../models/delivery-note-meta-data-response';
import { DeliveryNoteWithCertificationNumbersChecked } from '../models/delivery-note-with-certification-numbers-checked';
import { ExtractionRestartResponse } from '../models/extraction-restart-response';
import { getCarrierDeliveryNoteCombinedPdf } from '../fn/delivery-notes/get-carrier-delivery-note-combined-pdf';
import { GetCarrierDeliveryNoteCombinedPdf$Params } from '../fn/delivery-notes/get-carrier-delivery-note-combined-pdf';
import { getConsigneeAddonsDeliveryNotes } from '../fn/delivery-notes/get-consignee-addons-delivery-notes';
import { GetConsigneeAddonsDeliveryNotes$Params } from '../fn/delivery-notes/get-consignee-addons-delivery-notes';
import { getConsigneeDeliveryNoteCombinedPdf } from '../fn/delivery-notes/get-consignee-delivery-note-combined-pdf';
import { GetConsigneeDeliveryNoteCombinedPdf$Params } from '../fn/delivery-notes/get-consignee-delivery-note-combined-pdf';
import { getConsignorDeliveryNoteCombinedPdf } from '../fn/delivery-notes/get-consignor-delivery-note-combined-pdf';
import { GetConsignorDeliveryNoteCombinedPdf$Params } from '../fn/delivery-notes/get-consignor-delivery-note-combined-pdf';
import { getDeliveryNoteMetaData } from '../fn/delivery-notes/get-delivery-note-meta-data';
import { GetDeliveryNoteMetaData$Params } from '../fn/delivery-notes/get-delivery-note-meta-data';
import { getSingleDeliveryNoteMetaDataAddons } from '../fn/delivery-notes/get-single-delivery-note-meta-data-addons';
import { GetSingleDeliveryNoteMetaDataAddons$Params } from '../fn/delivery-notes/get-single-delivery-note-meta-data-addons';
import { patchDeliveryNoteConsigneeData } from '../fn/delivery-notes/patch-delivery-note-consignee-data';
import { PatchDeliveryNoteConsigneeData$Params } from '../fn/delivery-notes/patch-delivery-note-consignee-data';
import { putDeliveryNoteMetaData } from '../fn/delivery-notes/put-delivery-note-meta-data';
import { PutDeliveryNoteMetaData$Params } from '../fn/delivery-notes/put-delivery-note-meta-data';
import { restartDeliveryNoteExtraction } from '../fn/delivery-notes/restart-delivery-note-extraction';
import { RestartDeliveryNoteExtraction$Params } from '../fn/delivery-notes/restart-delivery-note-extraction';


/**
 * Endpoints to handle single delivery notes
 */
@Injectable({ providedIn: 'root' })
export class DeliveryNotesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSingleDeliveryNoteMetaDataAddons()` */
  static readonly GetSingleDeliveryNoteMetaDataAddonsPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}';

  /**
   * Get meta data for a single delivery note.
   *
   * Get the meta data for a single delivery note from the basic system
   * and enrich it with data from the addons system. This includes the
   * consignee order number, the certification number flags
   * (naturlandCertificationNumber, qsCertificationNumber and
   * gqbCertificationNumber) and the discrepancies on article level.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSingleDeliveryNoteMetaDataAddons()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getSingleDeliveryNoteMetaDataAddons$Response(params: GetSingleDeliveryNoteMetaDataAddons$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteWithCertificationNumbersChecked>> {
    const obs = getSingleDeliveryNoteMetaDataAddons(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get meta data for a single delivery note.
   *
   * Get the meta data for a single delivery note from the basic system
   * and enrich it with data from the addons system. This includes the
   * consignee order number, the certification number flags
   * (naturlandCertificationNumber, qsCertificationNumber and
   * gqbCertificationNumber) and the discrepancies on article level.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSingleDeliveryNoteMetaDataAddons$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getSingleDeliveryNoteMetaDataAddons(params: GetSingleDeliveryNoteMetaDataAddons$Params, context?: HttpContext): Observable<DeliveryNoteWithCertificationNumbersChecked> {
    const resp = this.getSingleDeliveryNoteMetaDataAddons$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DeliveryNoteWithCertificationNumbersChecked>): DeliveryNoteWithCertificationNumbersChecked => r.body)
    );
  }

  /** Path part for operation `patchDeliveryNoteConsigneeData()` */
  static readonly PatchDeliveryNoteConsigneeDataPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}';

  /**
   * Update the certification number flags or consignee order number for a delivery note.
   *
   * Update the certification number flags (naturlandCertificationNumber,
   * qsCertificationNumber, and gqbCertificationNumber) or the consignee
   * order number for a delivery note.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchDeliveryNoteConsigneeData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchDeliveryNoteConsigneeData$Response(params: PatchDeliveryNoteConsigneeData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = patchDeliveryNoteConsigneeData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update the certification number flags or consignee order number for a delivery note.
   *
   * Update the certification number flags (naturlandCertificationNumber,
   * qsCertificationNumber, and gqbCertificationNumber) or the consignee
   * order number for a delivery note.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchDeliveryNoteConsigneeData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchDeliveryNoteConsigneeData(params: PatchDeliveryNoteConsigneeData$Params, context?: HttpContext): Observable<void> {
    const resp = this.patchDeliveryNoteConsigneeData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `putDeliveryNoteMetaData()` */
  static readonly PutDeliveryNoteMetaDataPath = '/organizations/{organizationKey}/delivery-notes/{deliveryNoteKey}/metadata';

  /**
   * Add meta data to a delivery note.
   *
   * Update or add a new meta data entry to a delivery note. This can be
   * used to store additional information which is not part of the
   * standard delivery note.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putDeliveryNoteMetaData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putDeliveryNoteMetaData$Response(params: PutDeliveryNoteMetaData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = putDeliveryNoteMetaData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add meta data to a delivery note.
   *
   * Update or add a new meta data entry to a delivery note. This can be
   * used to store additional information which is not part of the
   * standard delivery note.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putDeliveryNoteMetaData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putDeliveryNoteMetaData(params: PutDeliveryNoteMetaData$Params, context?: HttpContext): Observable<void> {
    const resp = this.putDeliveryNoteMetaData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getDeliveryNoteMetaData()` */
  static readonly GetDeliveryNoteMetaDataPath = '/organizations/{organizationKey}/delivery-notes/{deliveryNoteKey}/metadata/{metaDataKey}';

  /**
   * Get the meta data of a delivery note.
   *
   * Get the meta data of a delivery note. This can be used to retrieve
   * additional information which is not part of the standard delivery
   * note.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeliveryNoteMetaData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryNoteMetaData$Response(params: GetDeliveryNoteMetaData$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteMetaDataResponse>> {
    const obs = getDeliveryNoteMetaData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the meta data of a delivery note.
   *
   * Get the meta data of a delivery note. This can be used to retrieve
   * additional information which is not part of the standard delivery
   * note.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeliveryNoteMetaData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryNoteMetaData(params: GetDeliveryNoteMetaData$Params, context?: HttpContext): Observable<DeliveryNoteMetaDataResponse> {
    const resp = this.getDeliveryNoteMetaData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DeliveryNoteMetaDataResponse>): DeliveryNoteMetaDataResponse => r.body)
    );
  }

  /** Path part for operation `getConsigneeAddonsDeliveryNotes()` */
  static readonly GetConsigneeAddonsDeliveryNotesPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes';

  /**
   * Get consignee delivery notes with controls flag.
   *
   * This endpoint returns a list of delivery notes for a consignee organization site,
   * wrapping the basic API endpoint and adding a controls flag to the response.
   * The controls flag indicates whether a delivery note has undergone
   * a specific check (true/false), such as the verification of the organic certification number.
   * This allows for tracing which delivery notes have been subjected to specific checks.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeAddonsDeliveryNotes()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getConsigneeAddonsDeliveryNotes$Response(params: GetConsigneeAddonsDeliveryNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeDeliveryNotesInPool>> {
    const obs = getConsigneeAddonsDeliveryNotes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get consignee delivery notes with controls flag.
   *
   * This endpoint returns a list of delivery notes for a consignee organization site,
   * wrapping the basic API endpoint and adding a controls flag to the response.
   * The controls flag indicates whether a delivery note has undergone
   * a specific check (true/false), such as the verification of the organic certification number.
   * This allows for tracing which delivery notes have been subjected to specific checks.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeAddonsDeliveryNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getConsigneeAddonsDeliveryNotes(params: GetConsigneeAddonsDeliveryNotes$Params, context?: HttpContext): Observable<ConsigneeDeliveryNotesInPool> {
    const resp = this.getConsigneeAddonsDeliveryNotes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsigneeDeliveryNotesInPool>): ConsigneeDeliveryNotesInPool => r.body)
    );
  }

  /** Path part for operation `restartDeliveryNoteExtraction()` */
  static readonly RestartDeliveryNoteExtractionPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/extraction/restart';

  /**
   * Restart a failed delivery note extraction.
   *
   * Restarts the article extraction process for a delivery note that has failed.
   * Only delivery notes with a FAILED articleStage can be restarted.
   * A delivery note can only be restarted once.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restartDeliveryNoteExtraction()` instead.
   *
   * This method doesn't expect any request body.
   */
  restartDeliveryNoteExtraction$Response(params: RestartDeliveryNoteExtraction$Params, context?: HttpContext): Observable<StrictHttpResponse<ExtractionRestartResponse>> {
    const obs = restartDeliveryNoteExtraction(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restart a failed delivery note extraction.
   *
   * Restarts the article extraction process for a delivery note that has failed.
   * Only delivery notes with a FAILED articleStage can be restarted.
   * A delivery note can only be restarted once.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restartDeliveryNoteExtraction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  restartDeliveryNoteExtraction(params: RestartDeliveryNoteExtraction$Params, context?: HttpContext): Observable<ExtractionRestartResponse> {
    const resp = this.restartDeliveryNoteExtraction$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExtractionRestartResponse>): ExtractionRestartResponse => r.body)
    );
  }

  /** Path part for operation `getConsignorDeliveryNoteCombinedPdf()` */
  static readonly GetConsignorDeliveryNoteCombinedPdfPath = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/complete-pdf';

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a consignor. The last page is the controls page.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsignorDeliveryNoteCombinedPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDeliveryNoteCombinedPdf$Response(params: GetConsignorDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    const obs = getConsignorDeliveryNoteCombinedPdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a consignor. The last page is the controls page.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsignorDeliveryNoteCombinedPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDeliveryNoteCombinedPdf(params: GetConsignorDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    const resp = this.getConsignorDeliveryNoteCombinedPdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /** Path part for operation `getCarrierDeliveryNoteCombinedPdf()` */
  static readonly GetCarrierDeliveryNoteCombinedPdfPath = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes/{deliveryNoteKey}/complete-pdf';

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a carrier. The last page is the controls page.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDeliveryNoteCombinedPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNoteCombinedPdf$Response(params: GetCarrierDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    const obs = getCarrierDeliveryNoteCombinedPdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a carrier. The last page is the controls page.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDeliveryNoteCombinedPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNoteCombinedPdf(params: GetCarrierDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    const resp = this.getCarrierDeliveryNoteCombinedPdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /** Path part for operation `getConsigneeDeliveryNoteCombinedPdf()` */
  static readonly GetConsigneeDeliveryNoteCombinedPdfPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/complete-pdf';

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a consignee. The last page is the controls page.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDeliveryNoteCombinedPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNoteCombinedPdf$Response(params: GetConsigneeDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    const obs = getConsigneeDeliveryNoteCombinedPdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a consignee. The last page is the controls page.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDeliveryNoteCombinedPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNoteCombinedPdf(params: GetConsigneeDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    const resp = this.getConsigneeDeliveryNoteCombinedPdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

}
